import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Meta from 'project/containers/meta';
import { MAX_SELECTED_REVISIONS } from 'presentations/constants';
import AddModal from 'presentations/containers/add_modal';

const New = ({ presentations, toggleAddModal }) => (
  <div className="presentations small-16 columns">
    <Meta title="Presentations" />
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <h3>Share Designs Privately With Others</h3>
        <p>
          Pick up to { MAX_SELECTED_REVISIONS} designs and invite your clients or others to
          your own branded mini-site,
          for their<br className="break-for-medium-up"/>feedback. You can launch a presentation
          mini-site at any time during your project.<br className="break-for-medium-up"/>For help
          with presentations, check out
          the <Link target="_blank" to="/help/managing-project/what-is-a-presentation/">
          Presentations Guide</Link>.
        </p>

        <div className="empty-state-cta">
          { presentations.length == 0 && <h3>You haven&apos;t created any Presentations yet.</h3> }
          <button className="btn btn-primary" onClick={toggleAddModal}>
            { presentations.length == 0 ? "Create a Presentation" : "Create Another Presentation" }
          </button>
        </div>
      </div>
    </div>
    <AddModal />
  </div>
);

New.propTypes = {
  presentations: PropTypes.array.isRequired,
  toggleAddModal: PropTypes.func.isRequired,
};

export default New;



// WEBPACK FOOTER //
// ./presentations/components/new.jsx